import { useSyncExternalStore } from 'react';

/**
 * Whether the browser believes it has a connection, kept current.
 *
 * A HINT, NOT A PROMISE. `navigator.onLine` is false only when there is certainly no network; a
 * phone on one bar of 4G reports true and then fails every request. So this is used to take the
 * offline path EARLY when the answer is certain — React Query pauses a request while offline rather
 * than failing it, and a page waiting on a paused request waits for ever — and never as proof that
 * a request will succeed.
 */
export function useOnline(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      window.addEventListener('online', onChange);
      window.addEventListener('offline', onChange);
      return () => {
        window.removeEventListener('online', onChange);
        window.removeEventListener('offline', onChange);
      };
    },
    () => navigator.onLine,
    () => true,
  );
}

/** The same hint, outside React — for a route guard. True where there is no navigator. */
export function isOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine;
}
